var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_gas",
    d: "M10.5,14H.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h10a.5.5,0,0,0,.5-.5v-1A.5.5,0,0,0,10.5,14ZM15.412,3.353,12.881.822a.5.5,0,0,0-.706,0l-.353.353a.5.5,0,0,0,0,.706L13,3.059V5a1.747,1.747,0,0,0,1.5,1.725V11.75a.75.75,0,0,1-1.5,0v-1A2.75,2.75,0,0,0,10.25,8H10V2A2,2,0,0,0,8,0H3A2,2,0,0,0,1,2V13h9V9.5h.25a1.25,1.25,0,0,1,1.25,1.25v.869a2.343,2.343,0,0,0,2.016,2.372A2.256,2.256,0,0,0,16,11.75V4.769a2,2,0,0,0-.588-1.416ZM8,6H3V2H8Z",
    fill: "#41cc41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/gas.4b8143d4d7751159a3abca52a36e4038.svg";
export { ForwardRef as ReactComponent };